import React from 'react';
import { createRoot } from 'react-dom/client';
import SignupPage from '../src/components/signupPage/SignupPage';

document.addEventListener('DOMContentLoaded', () => {
  const params = document.getElementById('signupParams');
  const orgType = params.getAttribute('orgType');
  const user = JSON.parse(params.getAttribute('user'));
  const userType = params.getAttribute('userType');

  const container = document.body.appendChild(document.createElement('div'))
  const root = createRoot(container)

  root.render(
    <SignupPage
      orgType={orgType}
      user={user}
      userType={userType}
    />
  );
});
